import { Card } from "@coherence-design-system/controls";
import { ActionButton, FontSizes, FontWeights, Pivot, PivotItem } from "@fluentui/react";
import { Stack, IStackTokens, IStackProps } from '@fluentui/react/lib/Stack';
import { AccountDetail } from "./AccountDetail";
import "./Account.css"
import { Quotation } from "../Quotes/Quotation";
import React, { useEffect, useState } from "react";
import { CustomerAccountDetail } from "../../models/Accounts/IAccountDetail";
import { AccountDetailService } from "../../services/Accounts/AccountDetailService";
import { useNavigate } from "react-router-dom";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
const stackTokens: Partial<IStackTokens> = { childrenGap: 10 };

interface IAccountDetailState {
    loading: boolean,
    accountDetails: CustomerAccountDetail,
    errorMsg: string
}

export const Overview: React.FunctionComponent = () => {

    const columnProps: Partial<IStackProps> = {
        tokens: { childrenGap: 5 },
        styles: { root: { width: 200 } },
    };

    const navigate = useNavigate();

    const appInsights = useAppInsightsContext();

    const goBack = () => {
        navigate(-1);
        appInsights.trackEvent({name:"OnClickGoBack"})
    };
    const [aDetail, setDetail] = useState<IAccountDetailState>({
        loading: false,
        accountDetails: {} as CustomerAccountDetail,
        errorMsg: ''
    })

    useEffect(() => {
        appInsights.trackTrace({message: "API call started: AccountDetailService -> GetAccountDetail() in Overview.tsx"});
        AccountDetailService.getAccountDetail('bfe0ef5a-bd3b-4486-99ce-72d0fbcf35c2')
            .then((res) => {
                //console.log(res.data.data);
                if (res !== undefined) {
                    setDetail({
                        ...aDetail,
                        loading: false,
                        accountDetails: res.data.data
                    })
                }
            })
            .catch((err) =>
            {
                appInsights.trackException({error: err, properties: {name: "In Overview.tsx, error while retrieving account details."}});
                setDetail({
                    ...aDetail,
                    loading: false,
                    errorMsg: err.message
                })
            });
            appInsights.trackTrace({message: "API call ended: AccountDetailService -> GetAccountDetail() in Overview.tsx"});    
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { accountDetails } = aDetail;
    console.log(accountDetails);



    return (
        <Stack
            tokens={stackTokens}>
            <div>
                <ActionButton iconProps={{ iconName: 'ChevronLeft' }} onClick={goBack}></ActionButton>
                <Card>
                    <Stack horizontal>
                        <Stack>
                            <span>{accountDetails?.accountNumber}</span>
                            <span style={{ fontWeight: FontWeights.bold, fontSize: FontSizes.large }}><b>{accountDetails?.billingAccount}</b></span>
                        </Stack>
                    </Stack>
                    <Stack horizontal>
                        <Stack {...columnProps}>
                            <span>Billing Account owner</span>
                            <span>{accountDetails?.accountOwner}</span>
                        </Stack>
                        <Stack {...columnProps}>
                            <span>Trade screening status</span>
                            <span>Confirmed</span>
                        </Stack>
                        <Stack {...columnProps}>
                            <span>Sell To</span>
                            <span>{accountDetails?.soldTo}</span>
                        </Stack>
                    </Stack>
                    <Pivot aria-label="Quotations">
                        <PivotItem headerText="Account Detail" style={{ backgroundColor: "whitesmoke" }}>
                            <AccountDetail />
                        </PivotItem>
                        <PivotItem headerText="Quotations" style={{ backgroundColor: "whitesmoke" }}>
                            <Quotation />
                        </PivotItem>
                    </Pivot>
                </Card>
            </div>
        </Stack>
    );
}